import { Link } from "react-router-dom";
import config from "../../Admin/Config.json";
import { useEffect, useState } from "react";

export default function HomeAbout({ homeAboutData, aboutimages }) {

  const { content, heading, media, ShowInWebSite } = homeAboutData;

  const [show, setShow] = useState(true);
  useEffect(() => {
    ShowInWebSite === 1 ? setShow(true) : setShow(false);
  }, [homeAboutData]);
  const cards = [
    {
      title: content.cardTitles[0],
      img: media.cardImages[0],
    },
    {
      title: content.cardTitles[1],
      img: media.cardImages[1],
    },
    {
      title: content.cardTitles[2],
      img: media.cardImages[2],
    },
    {
      title: content.cardTitles[3],
      img: media.cardImages[3],
    },
  ];
  return (
    show && (
      <div>
        <div className="home-aboutus">
          <div className="home-about">
            <div className="home-aboutus-description">
              <h2>{heading}</h2>
              <p>{content.content}</p>
            </div>
            <div className="home-about-item">
              <ul>
                {cards.map((card, index) => (
                  <li key={index}>
                    <div>
                      <img src={config.awsMediaPath + card.img} />
                    </div>
                    <div>
                      <p>{card.title}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
            <div className="gettoknow">
              <div className="line1">
                <p>
                  <Link to="./about">{content.buttonContent}</Link>
                </p>
                <img src={aboutimages.line1} />
              </div>
              <div className="elipse">
                <img src={aboutimages.elipse} />
              </div>
            </div>
          </div>
          <div className="home-about-img">
            {/* <img src={aboutimages.homeaboutright} alt="about image" /> */}
            <img
              src={config.awsMediaPath + media.featureImage}
              alt="about image"
            />
          </div>
        </div>
        <div className="home-about-bottom">
          <ul>
            {media.productImages.map((productImage, key) => (
              <li key={key}>
                <img src={config.awsMediaPath + productImage} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  );
}
